import "../../Components/Page/Page.css";
import "../../Pages/Investment/Investment.css";

import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import QuoteComp from "../../Components/QuoteComp/QuoteComp";

const RevenueScenario: React.FC = () => {
  return (
    <div className="sectionContainer">
      <SecHeader title="Revenue Scenario" />
      <SubSection>
        <QuoteComp
          text={
            "Using Wankel as an example, Wankel was able to leverage his IP to all 25 global car companies in 1960 into an exclusive $50-million licensing and prototyping deal with GM — $400-million in today's money."
          }
        />
        <div className="inv-items">
          <div className="inv-item">
            <h4 className="inv-item-title">E-SPEC SaaS</h4>
            <p className="inv-item-body">
              $1-million for 3 years access to our continuously researched data and exclusive design
              tools to show the performance improvements of ELF-Tech innovations and its market advantages.
            </p>
          </div>
          <div className="inv-item">
            <h4 className="inv-item-title">Parts' CADs Sales From Our Growing Library</h4>
            <p className="inv-item-body">
              $10-million for prototyping and building test engines, and $100-million for US
              exclusivity for 2 years if desired.
            </p>
          </div>
          <div className="inv-item">
            <h4 className="inv-item-title">Prototyping Licenses With or Without Exclusivity</h4>
            <p className="inv-item-body">
              Prototyping licensees can explore how ELF-Tech innovations give their product the best
              edge in power, weight, efficiency, emissions and costs. ELF-Tech designs will become the
              "must use" global gold standard.
            </p>
          </div>
          <div className="inv-item">
            <h4 className="inv-item-title">Production Licenses</h4>
            <p className="inv-item-body">
              A selection of ELF-Tech parts and engines from our extensive library of Computer Aided Designs.
            </p>
          </div>
        </div>
      </SubSection>
    </div>
  );
};

export default RevenueScenario;
